// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"f451a07c","3362":"5d74cb3c","8516":"7045bbcf","9899":"98833587"}[chunkId] + ".chunk.css";
};